<template>
  <section>
    <ul class="sidemenu">
      <li
        v-for="(menu, i) in mainMenuCom"
        :key="i"
        @click="menuToggle(i)"
        :class="[menu.icon ? 'p_30' : '']"
      >
        <router-link
          v-if="menu.hasMail"
          to="mailto:Support@risingx.io"
          class="mail highlight highlight__400 text16 menu__icon"
        >
          <img :src="menu.icon" alt="" />
          {{ $t(menu.label) }}
        </router-link>
        <h6
          v-else
          class="highlight highlight__400"
          :class="[!menu.beta ? 'disable-menu' : '']"
        >
          <div
            class="menu-list menu__icon"
            :class="[
              menu.subMenuToggle ||
              menu.isActive ||
              (menuHover[menu.key] && menu.beta)
                ? 'menu-active'
                : '',
              `${menu.class}`,
            ]"
            @click="menuClickHandler(menu)"
            @mouseenter="hoverHandler('enter', menu)"
            @mouseleave="hoverHandler('leave', menu)"
          >
            <img
              v-if="menu.isLogin"
              :src="
                menu.isActive ||
                menu.subMenuToggle ||
                (menuHover[menu.key] && menu.beta)
                  ? menu.activeIcon
                  : menu.icon
              "
            />
            {{ $t(menu.label) }}
            <span v-if="!menu.beta" class="sentence sentence__600 soon"
              >Soon</span
            >
          </div>
          <div v-if="menu.icon" class="arrow-btn">
            <img v-if="menu.beta && menu.depth === 1" :src="ArrowDown" alt="" />
            <img v-else-if="menu.depth === 2" :src="ArrowUp" alt="" />
          </div>
          <div v-else class="arrow-btn">
            <img
              v-if="menu.beta && menu.depth === 1"
              :src="ArrowDownW"
              alt=""
            />
            <img v-else-if="menu.depth === 2" :src="ArrowUp" alt="" />
          </div>
        </h6>

        <Transition name="slide">
          <ul
            v-if="menu.subMenuToggle"
            class="menu__sub"
            @click.stop
            :class="[!menu.subMenu.icon ? 'header-mobile' : '']"
          >
            <li
              v-for="subMenu in menu.subMenu"
              :key="subMenu"
              class="highlight size__down"
            >
              <div
                class="submenu"
                :class="[
                  !subMenu.beta ? 'disable-menu' : '',
                  subMenu.isActive ? 'menu-active' : '',
                ]"
                @click="subMenuClickHandler(subMenu)"
                @mouseenter="hoverHandler('enter', subMenu)"
                @mouseleave="hoverHandler('leave', subMenu)"
              >
                <span
                  v-if="subMenu.icon"
                  class="submenu__icon"
                  :class="isStore ? 'store-menu' : ''"
                >
                  <img
                    :src="
                      subMenu.isActive || menuHover[subMenu.key]
                        ? subMenu.activeIcon
                        : subMenu.icon
                    "
                    alt=""
                  />
                </span>
                <!-- {{ $t(subMenu.label) }} -->
                <template v-if="subMenu.key === 'kibotZoneList'">
                  1% {{ $t(subMenu.label) }}
                </template>
                <template v-else>
                  {{ $t(subMenu.label) }}
                </template>
              </div>
            </li>
          </ul>
        </Transition>

        <div v-if="menu.showHr" class="gradient-line"></div>
      </li>
    </ul>
  </section>
</template>

<script setup>
import {
  ref,
  toRef,
  defineProps,
  defineEmits,
  computed,
  onMounted,
  watch,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
// main menu icon
import ArrowUp from "@/assets/images/layouts/sideBar/mainMenu/arrow_up.svg";
import ArrowDown from "@/assets/images/layouts/sideBar/mainMenu/arrow_down.svg";
import ArrowDownW from "@/assets/images/layouts/sideBar/mainMenu/arrow_down_white.svg";

const props = defineProps({
  mainMenu: Array,
  isStore: Boolean,
});
const mainMenuRef = toRef(props?.mainMenu);
const showContent = ref(false);
const menuHover = ref({});
// const popupStore    = usePopupList();
const menuKeyArr = props?.mainMenu?.map((ob) => ob.key)?.filter((ob) => ob);
// const localePath    = useLocalePath();

const route = useRoute();
const router = useRouter();
const store = useStore();
const mainMenuCom = computed(() => {
  return props.mainMenu;
});

menuKeyArr?.forEach((ob) => {
  menuHover.value[ob] = false;
});

const hoverHandler = (type, item) => {
  switch (type) {
    case "enter":
      menuHover.value[item.key] = true;
      break;
    case "leave":
      menuHover.value[item.key] = false;
      break;
  }
};

const menuToggle = (i) => {
  if (mainMenuRef.value[i].beta && mainMenuRef.value[i].depth === 1) {
    mainMenuRef.value[i].subMenuToggle = true;
    mainMenuRef.value[i].depth = 2;
  } else if (mainMenuRef.value[i].beta && mainMenuRef.value[i].depth === 2) {
    mainMenuRef.value[i].subMenuToggle = false;
    mainMenuRef.value[i].depth = 1;
  }
};

const emit = defineEmits(["openContent"]);

const menuClickHandler = (item) => {
  // const router = useRouter();
  // const userStore = useUserStore();
  // // popupStore.openBetaPopup(false);

  // if(userStore.isAdmin && item.key === "profit_status") {
  //     return router.push("/inputImage");
  // }
  store.dispatch("usePopupList/openBetaPopup", false);
  if (!item.beta) {
    store.dispatch("usePopupList/openBetaPopup", true);
    // popupStore.openBetaPopup(true);
    return;
  }

  if (item.hasSubmenu) return;

  // if(item.key === "inquriy" || item.key === "store_inquriy") {
  //     // popupStore.openInquiryModal(true);
  // }

  // const lang_code = useCookie('i18n_redirected').value;
  // console.log('lang_code',lang_code);

  router.push({
    path: item.route,
    // path : localePath(item.route, lang_code),
    query: {
      menuName: item.key,
    },
  });
  emit("openContent", showContent.value);
};

const subMenuClickHandler = (item) => {
  // console.log('item',item);

  // popupStore.openBetaPopup(false);
  store.dispatch("usePopupList/openBetaPopup", false);
  if (!item.beta) {
    // popupStore.openBetaPopup(true);
    store.dispatch("usePopupList/openBetaPopup", true);
    return;
  }
  store.dispatch("useMainMenuList/setMenuStatus", item.key);
  // const lang_code = useCookie('i18n_redirected').value;
  router.push({
    path: item.route,
    // path : localePath(item.route, lang_code),
    query: {
      menuName: item.key,
    },
  });
  emit("openContent", showContent.value);
};

const setActiveMenuBasedOnRoute = () => {
  const currentRoutePath = route.path;
  const menuName = route.query.menuName;

  props.mainMenu.forEach((menu) => {
    if (menu.route === currentRoutePath) {
      store.dispatch("useMainMenuList/setMenuStatus", menu.key);
    }

    if (menu.subMenu) {
      menu.subMenu.forEach((subMenu) => {
        if (subMenu.key === menuName) {
          store.dispatch("useMainMenuList/setMenuStatus", subMenu.key);
        }
      });
    }
  });
};

// Set active menu when component is mounted
onMounted(() => {
  setActiveMenuBasedOnRoute();
});

// Watch for route changes
watch(
  () => route.path,
  () => {
    setActiveMenuBasedOnRoute();
  }
);
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/common/login/SideMenu.scss";
</style>
